/* realsport 比赛列表单个 event 相关数据 bus */
import { generateArray } from '@ms/utils/array'

const marketBus = new Map()
const superMarketBus = new Map()

const defaultMarketInfo = {
  titles: [],
  outcomeNumber: 3
}

// 解析普通 market titles
const getMarketTitles = (title) => title && title.split(',')
// 解析 special market titles
const getSpecialMarketTitles = (presentationType, outcomeNumber, title) => {
  if (presentationType === 7) {
    const titles = generateArray(1, 4)
    return titles
  }

  if (presentationType === 8) {
    // If outcomeNumber is 5, then titles will be [0, 1, 2, 3, 4+]
    const titles = generateArray(0, outcomeNumber - 1)
    titles[titles.length - 1] = titles[titles.length - 1] + '+'
    return titles
  }

  return getMarketTitles(title)
}

const getMarketMap = (markets, basicMap = {}, idType = '') =>
  markets.reduce((obj, x) => {
    const { id, title, outcomeNumber } = x
    const titles = getMarketTitles(title)
    if (idType) {
      if (obj[idType]) {
        obj[idType].push(id)
      } else {
        obj[idType] = [id]
      }
    }
    obj[id] = { id, titles, outcomeNumber }
    return obj
  }, basicMap)

export const setMarketInfo = (sportId = '', { markets = [], otherDefaultMarkets = [], otherMarkets = [] }) => {
  let marketMap = getMarketMap(markets, {}, 'defaultIds')
  if (otherDefaultMarkets.length) {
    marketMap = getMarketMap(otherDefaultMarkets, marketMap)
  }
  if (otherMarkets.length) {
    otherMarkets.forEach(({ marketInfos }) => {
      marketMap = getMarketMap(marketInfos, marketMap)
    })
  }
  marketBus.set(sportId, marketMap)
}

export const getMarketInfo = (sportId = '', marketId = '') => {
  const markets = marketBus.get(sportId)
  return markets ? markets[marketId] : defaultMarketInfo
}

export const getMarketIds = (sportId = '') => {
  const markets = marketBus.get(sportId)
  return markets ? markets.defaultIds : []
}

export const clearMarketInfo = () => marketBus.clear()

export const setSuperMarketInfo = (sportId = '', markets = []) => {
  const marketMap = markets.reduce((obj, x) => {
    const { id, outcomeNumber, presentationType, guidance, title } = x
    const titles = getSpecialMarketTitles(presentationType, outcomeNumber, title)
    obj[id] = { id, outcomeNumber, presentationType, guidance, titles }
    return obj
  }, {})

  superMarketBus.set(sportId, marketMap)
}

export const getSuperMarketInfo = (sportId = '', marketId = '') => {
  const allMarkets = {
    ...superMarketBus.get(sportId),
    ...marketBus.get(sportId)
  }

  if (marketId in allMarkets) {
    return allMarkets[marketId]
  }

  return defaultMarketInfo
}

export const clearSuperMarketInfo = () => superMarketBus.clear()

export const isSpecialMarket = (options = {}) => {
  const { sportId, marketId } = options

  if (!superMarketBus.has(sportId)) {
    return false
  }

  const markets = superMarketBus.get(sportId)
  return marketId in markets
}
